import InProgressPage from './InProgressPage';

export default InProgressPage;
